// extracted by mini-css-extract-plugin
export default {"main":"AboutManufacturing_main__9Jn7B","imageSideFlex":"AboutManufacturing_imageSideFlex__xYRDT","sideContent":"AboutManufacturing_sideContent__drgoi"};